import { createContext, useContext } from 'react'

import LoadingStatus from 'state/enums/LoadingStatus'

import { LeadsPageContextData } from './types'

export const LeadsPageContext = createContext<LeadsPageContextData>({
    search: '',
    setSearch: () => undefined,
    applicationFilters: {
        prequalifiedLeads: false,
        declinedLeads: false,
        preApprovedLeads: false,
        dealershipIds: [],
    },
    setApplicationFilters: () => undefined,
    setDealershipIds: () => undefined,
    loadingStatus: LoadingStatus.IDLE,
    setLoadingStatus: () => undefined,
    leadsSearchResults: [],
    setLeadsSearchResults: () => undefined,
})

function useLeadsPageContext() {
    return useContext(LeadsPageContext)
}

export default useLeadsPageContext
